import React from 'react';
import '../assests/css/Contact.css';
import Footer from '../Components/Footers/Footer';
import Header from '../Components/Headers/Header';
import { faPhone, faEnvelope, faLocationArrow } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ContactUs = () => {


    return (
        <div className='contactus'>
            <section className='bg-privacy-policy-top mb-3'>
                <Header />
                <div className='container px-5'>
                    <div className='row px-3'>
                        <div className='col-lg-12 my-4 text-center'>
                            <p className='text-white f-72 my-5 f-pop-med'>Contact Us</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className='mb-5'>
                <div className='container '>
                    <div className='row'>
                        <div className='col-lg-12 mt-5 mb-3'>
                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2462.509856952507!2d0.2561327156693171!3d51.888158990612936!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47d88e5c3a5b4b29%3A0x3fdf8e8e8b0fc31e!2sEnterprise%20House%2C%20Bassingbourn%20Rd%2C%20Stansted%20CM24%201QW%2C%20UK!5e0!3m2!1sen!2s!4v1648641880876!5m2!1sen!2s" style={{ border: "0", height: "450px", width: "100%", border: "0" }} allowFullScreen={true} loading="lazy" />
                        </div>
                        <div className='col-lg-7 mt-5 mb-5'>
                            <div className='row '>
                                <div className='col-lg-6'>
                                    <p className='f-mon-med f-15 clr-3d mb-2'>First Name</p>
                                    <input type='text' placeholder='Enter your First name' className="form-control f-12 f-pop-reg inpt-fld-contactus mb-4" />
                                </div>
                                <div className='col-lg-6'>
                                    <p className='f-mon-med f-15 clr-3d mb-2'>Last Name</p>
                                    <input type='text' placeholder='Enter your Last name' className="form-control f-12 f-pop-reg inpt-fld-contactus mb-4" />
                                </div>
                                <div className='col-lg-12'>
                                    <p className='f-mon-med f-15 clr-3d mb-2'>Email Adress</p>
                                    <input type='text' placeholder='Enter your Email Address' className="form-control f-12 f-pop-reg inpt-fld-contactus mb-4" />
                                </div>
                                <div className='col-lg-12'>
                                    <p className='f-mon-med f-15 clr-3d mb-2'>Contact</p>
                                    <input type='text' placeholder='Enter your Contact Number' className="form-control f-12 f-pop-reg inpt-fld-contactus mb-4" />
                                </div>
                                <div className='col-lg-12'>
                                    <p className='f-mon-med f-15 clr-3d mb-2'>Message</p>
                                    <textarea type='text' className="form-control f-12 f-pop-reg inpt-fld-contactus mb-4" placeholder='Enter your Message ' style={{ resize: "none" }} rows={8} ></textarea>
                                </div>
                                <div className='col-lg-12'>
                                    <button className='btn btn-danger form-control p-3 clr-bt-contact' >Send Message</button>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-5 text-center mt-5 mb-5'>
                            <div className='card border-0'>
                                <div className='card-body crd-wdth-contact'>
                                    <FontAwesomeIcon className='star_contact mx-1' icon={faPhone} />
                                    <p className='clr-1c f-pop-semibold f-24'>Talk To Us</p>
                                    <p className='clr-0e'>Toll-Free: <span className='clr-92'>+441279-247-247</span> </p>
                                    {/* <p>Fax: <span>+01279-247-247</span> </p> */}
                                    <div className='brdr-btm-light-contact'>

                                    </div>
                                </div>
                            </div>

                            <div className='card border-0'>
                                <div className='card-body crd-wdth-contact'>
                                    <FontAwesomeIcon className='star_contact mx-1' icon={faEnvelope} />
                                    <p className='clr-1c f-pop-semibold f-24'>Contact us</p>
                                    <p className='clr-92'>customersupport@metro247.com</p>
                                    {/* <p className='clr-92'>Loremipsum@gmail.com</p> */}
                                    <div className='brdr-btm-light-contact'>
                                    </div>
                                </div>
                            </div>

                            <div className='card border-0'>
                                <div className='card-body crd-wdth-contact'>
                                    <FontAwesomeIcon className='star_contact mx-1' icon={faLocationArrow} />
                                    <p className='clr-1c f-pop-semibold f-24'>Location</p>
                                    <p className='clr-92'>Enterprise House London Stansted Airport, Enterprise House, Bassingbourn Rd, Stansted CM24 1QW</p>
                                    <p className='clr-92'>Head office for correspondence Unit 3A, Mill Court, Harlow CM20 2JA</p>
                                    {/* <div className='brdr-btm-light-contact'>
                                    </div> */}
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

            </section>

            <Footer />
        </div>
    )
}

export default ContactUs;